/**
 * 联系人信息
 * @author Created by jiamei.yao 2017/05/22
 */


'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, ScrollView, Image} from 'react-native';
import ReactDom from "react-dom";

import { observer, inject } from 'mobx-react';
import {autorun} from 'mobx';

import Icon from '../../../../components/Icon';

import styles from './style';
import QImageSet from '../../../../assets/QImageSet';
import {getScreenSize} from "../../../../common/utils";


@inject(stores => {
    const {lowPriceDataStore, searchDataStore} = stores,
        {depCityListComp} = searchDataStore,
        {lowPriceData,setFilter, selectedFilter, setLocation, setLowPriceDepCity,
            lowPriceDepCity, loading, successToast, firstReq} = lowPriceDataStore,
        {filters} = lowPriceData;
    return {
        firstReq,
        loading,
        successToast,
        selectedFilter,
        setLocation,
        filters,
        setFilter,
        lowPriceDepCity,
        setLowPriceDepCity,
        depCityListComp
    };
})

@observer
class Filter extends Component {
    constructor(props) {
        super(props);
        this.filterXMap = {};
        autorun(() => {
            let curLayout = this.filterXMap[this.props.selectedFilter] || {};
            this.filterScrollRef && this.filterScrollRef.scrollTo({x:curLayout.x + curLayout.width /2 - (getScreenSize().width -  88) /2})
        })
    }

    componentWillUpdate(){
        this.filtersRef = [];
    }

    componentDidUpdate(){
        let {filters} = this.props || {};
        if(filters && this.filtersRef.filter((item) => {return ReactDom.findDOMNode(item) !== null}).length === filters.length) {
            this.filtersRef.forEach((e, index) => {
                let dom = ReactDom.findDOMNode(e);
                if(dom) {
                    this.filterXMap[filters[index].title] = {
                        x: dom.offsetLeft,
                        width: dom.offsetWidth
                    };
                }
            });
        }
    }


    onPressLocation = () => {
        GodEye.log({
            r: 'location_click'
        });

        this.props.depCityListComp.show({
            selectedCityList: [{ name: this.props.lowPriceDepCity }],
            successCallback: (data) => {
                let result = data && data[0];
                let { search, name } = result;
                this.props.setLowPriceDepCity(search || name);
            }
        })
    };

    render() {
        let {filters, lowPriceDepCity, loading, firstReq} = this.props;

        return (
            <View style={styles.filterWrapper}>
                <View style={styles.filterScrollWrapper}>
                    {/*为了隐藏滚动条*/}
                    <View style={styles.scrollHeight}>
                        <ScrollView style={styles.timeFilter} ref={(e) => {this.filterScrollRef = e}} horizontal={true}>
                            <View style={{flexDirection: 'row'}}>
                                {filters ? filters.map((item, index) => {
                                    let active = this.props.selectedFilter ? this.props.selectedFilter === item.title : index === 0;
                                    return (
                                        <TouchableOpacity
                                            ref={(e)=>{this.filtersRef[index] = e}}
                                            style={styles.timeFilterItem}
                                            key={item.title}
                                            onPress={() => {
                                                GodEye.log({
                                                    r: 'time_filter_click',
                                                    filter: item.title
                                                });
                                                this.props.setFilter(item.title)
                                            }}
                                        >
                                            <View style={styles.timeFilterItemTitle}>
                                                <Text style={[styles.timeFilterItemTitleText,
                                                    active ? styles.activeTimeFilterItemTitleText : {}]}
                                                >{item.title}</Text>
                                            </View>
                                            {item.subTitle
                                                ? <View
                                                    style={[styles.timeFilterSubTitle, active ? styles.activeTimeFilterSubTitle : {}]}>
                                                    <Text style={[
                                                        styles.timeFilterItemSubTitleText,
                                                        active ? styles.activeTimeFilterItemSubTitleText : {}
                                                    ]}>
                                                        {item.subTitle}
                                                    </Text>
                                                </View>
                                                : null}
                                        </TouchableOpacity>
                                    )
                                }) : null}
                            </View>
                        </ScrollView>
                    </View>
                </View>
                {
                    (firstReq && loading) ?  null : <TouchableOpacity style={styles.placeFilter} onPress={this.onPressLocation}>
                        <Image source={{uri: QImageSet.shadowTab}} style={styles.shadowFilter}/>
                        <View style={styles.placeFilterCity}>
                            <Text style={styles.placeFilterCityText} numberOfLines={1} ellipsizeMode={'tail'}>{lowPriceDepCity}</Text>
                            <Icon name='down' color='#00cad8' size={6} style={styles.placeFilterDown}/>
                        </View>
                        <Text style={styles.placeFilterGoTip}>出发</Text>
                    </TouchableOpacity>
                }

            </View>
        )
    }
}

export default Filter;
